import React = require("react")
import { GroupedOverviewEvent } from "../../../../backendApi/generated"
import { features } from "../../../../features"
import { Link } from "../../../Link"
import { Text } from '../../../Text'
import { moment } from "../../../../utils/moment"
import { formatDatesShort } from "../../EventUtils"

const nextEvent = (event: GroupedOverviewEvent) => {
  if (!event.ChildEvents || event.ChildEvents.length == 0) return event

  const next = event.ChildEvents[0]
  if (next.Kind == 'single') return next
  return nextEvent(next)
}

export const EventOverviewResultBlock = (props: { label: string, events: GroupedOverviewEvent[] }) => props.events.length > 0 && <>
  <h4>{props.label}</h4>
  <ul className="a-content__list">
    {props.events.map(event => <EventOverviewResultItem {...{ event }} key={`event__${event.Id}`} />)}
  </ul>
</>

export const EventOverviewResultItem = (props: { event: GroupedOverviewEvent }) => {
  const { event: { Title, ShortDescription, TargetId, Start, End, Locations, Image, SpansMultipleDays } } = props
  const config = features().events
  if (config == 'off') return null

  const linkProps = { url: `${config.prefix}/${TargetId}` }

  // If there's more than 1 location, we attach an alphabetized list as title on the `address` element
  const [locationName, addressAttributes] = Locations.length == 1
    ? [nextEvent(props.event).Locations[0]?.Name, {}]
    : ["Meerdere locaties", { title:  Locations.map(l => l.Name).sort().join('\n')}]

  return <li className="a-item">
    <Link className="a-item__link" {...linkProps}>
      <div className="a-item__content">
        <div className="a-item__text">
          <h4 className="a-item__title title--ms"><span>{Title}</span></h4>
          {ShortDescription && Text(ShortDescription)}
        </div>

        <div className="a-item__meta">
          <span className="sr-text">Waar en wanneer: </span>
          <time dateTime={moment(Start).format('YYYY-MM-DD')}>
            {formatDatesShort(props.event)}
            <svg className="edition__icon" width="15" height="17" aria-hidden="true"><use xlinkHref="#icon--calendar" /></svg>
          </time>
          <address {...addressAttributes}>
            {locationName}
            <svg className="edition__icon" width="15" height="18" aria-hidden="true"><use xlinkHref="#icon--location" /></svg>
          </address>
        </div>

        {linkProps && <div className="a-item__fauxlink">
          <svg className="a-item__fauxlink-icon" width="8px" height="14px" aria-hidden="true"><use xlinkHref="#icon--chevron-right"></use></svg>
          <span>Bekijk activiteit</span>
        </div>}
      </div>

      <div className="a-item__visual">
        {Image ? (
          <img src={Image.Teaser} alt={Image.AltText} width="225" height="150" className="a-item__image" />
        ) : (
          <div className="a-item__placeholder"></div>
        )}
      </div>
    </Link>
  </li>
}

